export enum DateFilterId {
  CUSTOM = "custom",
  TODAY = "today",
  LAST_DAY = "lastDay",
  LAST_SEVEN = "lastSeven",
  LAST_WEEK = "lastWeek",
  LAST_THIRTY = "lastThirty",
  CURRENT_MONTH = "currentMonth",
  LAST_MONTH = "lastMonth",
  CURRENT_YEAR = "currentYear",
  LAST_YEAR = "lastYear",
}
